export enum EHeadAlign {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}
